import { ref } from 'vue';

export const TRANSACTION_TYPES = {

    CREATE : 'C',
    EDIT: 'E',
    SHOW: 'S',

};

export const ROLE_IDS = {
    0: 'SUPERADMIN',
    1: 'ADMIN',
    2: 'MEMBER',
    3: 'GUEST',
};

export const RISK_ZONES_STYLES = {

    RANGE: [
        { id: 4, style: 'bg-green-100 text-green-800' },
        { id: 3, style: 'bg-yellow-100 text-yellow-800' },
        { id: 2, style: 'bg-orange-100 text-orange-800' },
        { id: 1, style: 'bg-red-100 text-red-800' },
    ]

};

export const PASSWORDREQUIREMENTS = {
    minLength: false,
	lowercase: false,
    uppercase: false,
    number: false,
    specialChar: false,
};

export const CONTROLS_STATUSES = [

    { id: 1, status: { es: 'Activo', en: 'Active'} },
    { id: 6, status: { es: 'Implementado', en: 'Implemented'} }

];

export const STATUSES_IDS = {
    ACTIVE: 1,
    INACTIVE: 2,
    INVITED: 3,
    PENDING: 4,
    FINISH: 5,
    IMPLEMENTED: 6,
    MITIGATED: 7,
};

export const CURRENT_PAGE = ref(1);

export const ITEMS_PER_PAGE = 10;
